import React from 'react';
import { serviceCardData } from '../Data/All_Services_Data/allServices';
import ProductSlider from './ProductSlider';

const ServiceListingSlider = () => {

  const generateCardHTML = (cardContent) => {
      
          const truncateText = (text, length) => {
          return text.length > length ? text.substring(0, length) + '...' : text;
          };
      
          const title = truncateText(cardContent.title, 16); 
          const description = truncateText(cardContent.description, 100); 
      
          return `
          <div class="swiper-slide">
              <div class="service-3d">
                  <div class="service-3d_icon">
                      <img loading="lazy" style="width: auto; height: 150px; object-fit: cover;" src="${cardContent.imgSrc}" alt="${cardContent.title}Icon" title="${cardContent.title}"  >
                  </div>
                  <div class="service-3d_content">
                      <h3 style="" class="box-title">${title}</h3>
                      <p style="max-height: 80px; overflow: hidden;" class="service-3d_text">${description}</p>
                      <a href="${cardContent.link}" class="th-btn">
                      Read More
                      <i class="fas fa-arrow-right ms-2"></i>
                      </a>
                  </div>
              </div>
          </div>
          `;
      };
        
      const generateSliderHTML = (data) => {
          return data.map(generateCardHTML);
      };
      
      const cardHTMLDataForService = generateSliderHTML(serviceCardData);

  return (
    <div>
      <section className="gr-bg3" id="service-sec">
                <div className="round-container space">
                  <div className="container">
                    <div className="title-area text-center">
                      {/* <span className="sub-title">OUR SERVICES</span> */}
                      <h2 className="sec-title">
                        Why We Are the Top Choice for IT Solutions & Services
                      </h2>
                    </div>
                    <div className="slider-area">
                      <ProductSlider
                        cardData={cardHTMLDataForService}
                        slidesPerView={3}
                      />
                    </div>
                  </div>
                </div>
              </section>
    </div>
  )
}

export default ServiceListingSlider;
